import { useTranslation } from 'react-i18next';
import AppStatusContent from './app-status/AppStatus';

const OtherInfoCard = () => {
    const { t } = useTranslation();

    return (
        <s-section>
            <div className="flex flex-col gap-4">
                {/* <BlockStack gap={'150'}>
                    <Text as="p" variant="headingMd">
                        {t('DASHBOARD.APP_STATUS.TITLE')}
                    </Text>
                    <Text as="p" variant="bodyMd" tone="subdued">
                        {t('DASHBOARD.APP_STATUS.SUBTITLE')}
                    </Text>
                </BlockStack> */}
                {/* <CurrentPlan />
                <Divider /> */}
                <AppStatusContent />
            </div>
        </s-section>
    );
};

export default OtherInfoCard;
